import { ModuleWithProviders, NgModule } from '@angular/core';
import { HumanresourcesCommonSharedComponent } from './humanresources-common-shared.component';
import { ToolbarModule } from 'primeng/toolbar';
import { ButtonModule } from 'primeng/button';
import { HrToolbarModule } from './common/component/hr-toolbar/hr-toolbar.module';
import { HrFormButtonsModule } from './common/component/hr-form-buttons/hr-form-buttons.module';
import { DateFormatModule } from './common/pipe/date-format/date-format.module';
import { HrSearchButtonsModule } from './common/component/hr-search-buttons/hr-search-buttons.module';
import { HrAccordionModule } from './common/component/hr-accordion/hr-accordion.module';
import { ImageUploaderModule } from './common/component/image-uploader/image-uploader.module';
import { CalendarFooterButtonModule } from './common/calendar-footer-button/calendar-footer-button.module';
import { ToUppercaseDirective } from './common/directive/ui-uppercase.directive';
import { DashletModule } from './common/component/dashlet/dashlet.module';
import { HrWidgetPageTitleModule } from "./common/hr-widget-page-title/hr-widget-page-title.module";

import { TableResponsiveDirective } from './directives/table-responsive.directive';

// @dynamic
@NgModule({
    declarations: [HumanresourcesCommonSharedComponent, ToUppercaseDirective, TableResponsiveDirective],
    imports: [
        HrToolbarModule,
        ToolbarModule,
        ButtonModule,
        HrFormButtonsModule,
        DateFormatModule,
        HrSearchButtonsModule,
        HrAccordionModule,
        ImageUploaderModule,
        CalendarFooterButtonModule,
        HrWidgetPageTitleModule
    ],
    exports: [
        HumanresourcesCommonSharedComponent,
        HrFormButtonsModule,
        HrToolbarModule,
        DateFormatModule,
        HrSearchButtonsModule,
        HrAccordionModule,
        ImageUploaderModule,
        CalendarFooterButtonModule,
        ToUppercaseDirective,
        DashletModule,
        HrWidgetPageTitleModule,
        TableResponsiveDirective
    ],
})
export class HumanresourcesCommonSharedModule {
    static forRoot(): ModuleWithProviders<HumanresourcesCommonSharedModule> {
        return {
            ngModule: HumanresourcesCommonSharedModule,
        };
    }
}
